<template>
    <div class="container max-w-3xl mx-auto mt-8 py-8 text-center" v-if="show">
        <p class="text-red">
            <img class="inline mr-2" src="../../assets/images/exclamation-mark.svg" alt="" width="17" height="17" />
            Sorry, but we weren't able to reserve the same appointment slot.
        </p>

        <div class="pt-12">
            <button type="button"
                    role="button"
                    class="btn btn-primary inline"
                    @click="$router.push({ name: 'home' })"
            >Start again</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'reserve-same-appointment-failed',

        data() {
            return {
                show: false,
            };
        },

        mounted() {
            this.listen('appointment.reserve.error', this.ohDear);
        },

        destroyed() {
            this.silence('appointment.reserve.error', this.ohDear);
        },

        methods: {
            ohDear() {
                this.show = true;
            },
        },
    }
</script>
